"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var DetailsModel = function DetailsModel(json, lang) {
  var data = [];
  data.all = {
    title: '',
    creads: []
  };

  if (json.establishment_cread_collections.length > 0) {
    var allItems = [];
    var cread_collections = {};

    for (var i = 0; i < json.establishment_cread_collections.length; i++) {
      var collection = json.establishment_cread_collections[i].cread_collection;
      var title = collection.name ? collection.name : "CreAds";
      var items = [];

      for (var j = 0; j < collection.creads.length; j++) {
        var col_item = collection.creads[j];
        var new_cread = {
          title: col_item.name ? col_item.name : "",
          image: col_item.image ? col_item.image : "",
          order: col_item.score
        };
        items.push(new_cread);
      } // Make sure the data is sorted in the right order


      var sortedItem = items.sort(function (a, b) {
        if (a.order < b.order) return 1;
        if (a.order > b.order) return -1;
      });
      cread_collections = {
        creads: sortedItem,
        title: title
      };
      data.push(cread_collections); // data.all.creads.push(sortedItem)

      for (var _i = 0; _i < cread_collections.creads.length; _i++) {
        data.all.creads.push(cread_collections.creads[_i]);
      }
    }
  }

  if (json.enterprise_cread_collections.length > 0) {
    var _allItems = [];
    var _cread_collections = {};

    for (var _i2 = 0; _i2 < json.enterprise_cread_collections.length; _i2++) {
      var _collection = json.enterprise_cread_collections[_i2].cread_collection;

      var _title = _collection.name ? _collection.name : "CreAds";

      var _items = [];

      for (var _j = 0; _j < _collection.creads.length; _j++) {
        var _col_item = _collection.creads[_j];
        var _new_cread = {
          title: _col_item.name ? _col_item.name : "",
          image: _col_item.image ? _col_item.image : "",
          order: _col_item.score
        };

        _items.push(_new_cread);
      } // Make sure the data is sorted in the right order


      var _sortedItem = _items.sort(function (a, b) {
        if (a.order < b.order) return 1;
        if (a.order > b.order) return -1;
      });

      _cread_collections = {
        creads: _sortedItem,
        title: _title
      };
      data.push(_cread_collections); // data.all.creads.push(sortedItem)

      for (var _i3 = 0; _i3 < _cread_collections.creads.length; _i3++) {
        data.all.creads.push(_cread_collections.creads[_i3]);
      }
    }
  }

  if (json.group_cread_collections.length > 0) {
    var _allItems2 = [];
    var _cread_collections2 = {};

    for (var _i4 = 0; _i4 < json.group_cread_collections.length; _i4++) {
      var _collection2 = json.group_cread_collections[_i4].cread_collection;

      var _title2 = _collection2.name ? _collection2.name : "CreAds";

      var _items2 = [];

      for (var _j2 = 0; _j2 < _collection2.creads.length; _j2++) {
        var _col_item2 = _collection2.creads[_j2];
        var _new_cread2 = {
          title: _col_item2.name ? _col_item2.name : "",
          image: _col_item2.image ? _col_item2.image : "",
          order: _col_item2.score
        };

        _items2.push(_new_cread2);
      } // Make sure the data is sorted in the right order


      var _sortedItem2 = _items2.sort(function (a, b) {
        if (a.order < b.order) return 1;
        if (a.order > b.order) return -1;
      });

      _cread_collections2 = {
        creads: _sortedItem2,
        title: _title2
      };
      data.push(_cread_collections2); // data.all.creads.push(sortedItem)

      for (var _i5 = 0; _i5 < _cread_collections2.creads.length; _i5++) {
        data.all.creads.push(_cread_collections2.creads[_i5]);
      }
    }
  }

  return data;
};

var _default = DetailsModel;
exports["default"] = _default;